import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { selectOneUsersGenerateDataExportItem, selectOneUsersListItems, selectOneUsersUploadCreateItem } from "../../../../../redux/one-users/selector";
import { useAppDispatch, useAppSelector } from "../../../../../hooks/hooks";
import { oneUsers } from "../../../../../redux/one-users/action";
import PageLoader from "../../../../../components/PageLoader";
import Table from "../../../../../common/components/table-manager/v1.1/table";
import { settings } from "../../../../../redux/settings/actions";
import moment from "moment";
import _ from "lodash";
import { accountTypes } from "../../../../../redux/account-types/action";
import { selectAccountTypesListItems } from "../../../../../redux/account-types/selector";
import UploadCommonModal from "../../../../../models/upload-common-modal";
import { selectCurrent } from "../../../../../redux/settings/selectors";
import { toast } from "react-toastify";



const OneUsers = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
    const { getCommonModal, getUploadModal } = useAppSelector(selectCurrent)
    const [exportsData, setExportsData] = useState<boolean>(false)
     const [selectAccountTypeId, setSelectAccountTypeId] = useState();
       const uploadOneuserAccountData = useSelector(selectOneUsersUploadCreateItem)
       const exportOneuserAccountData = useSelector(selectOneUsersGenerateDataExportItem)

  const accountTypeListData = useSelector(selectAccountTypesListItems)
    const OneUserItems = useSelector(selectOneUsersListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
         
          { field: 'Name', headerName: 'Name', searchField: 'Name', filter: true,
            filterType: 'text' },
            { field: 'Email', headerName: 'Email'},
            { field: 'PhoneNumber', headerName: 'PhoneNumber'},
            { field: 'CreatedOnUtc', headerName: 'CreatedOn', isDateValueFormat:true},
           
 

        ]);
      }


      const handleSearch = (data: any) => {
      
        let searchCriteria = {};
        if (data?.column){
          searchCriteria = [{
            FieldName: data?.column,
            FieldText: data?.column,
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        } else {
          searchCriteria = [{
            FieldName: "Name",
            FieldText: "Name",
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        }
    
        dispatch(oneUsers.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/one/one-users/list`,entity:'oneUser',jsonData:{
      
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
          "Searches": searchCriteria,
          }}))
      }
    
      

      const handleReloadData = () => {
        dispatch(oneUsers.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/one/one-users/list`,entity:'oneUser',jsonData:{
      
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
          
      
          }}))
      }
      const filterTypes = [{
        name: 'Text', value: "text"
      },
      {
        name: 'Number', value: "number"
      },
      {
        name: 'CheckBox', value: "checkbox"
      },
      {
        name: 'Date', value: "date"
      }
      ]
      const handleEdit=(data: any)=>{
        navigate(`${data?.Id}`)
      }
        
      const fetchOneuserList=()=>{
        dispatch(oneUsers.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/one/one-users/list`,entity:'oneUser',jsonData:{
      
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        
    
        }}))
      }

      const handleAdd = () => {
        navigate(`${0}`);
    };
     
      const additionButtons: any = [

        // {
        //   svg:
        //     <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
        //       <title>Add One Users</title>
        //       <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
        //     </svg>,
        //   callback: () => handleAdd(),
        // },
      
        {
          svg:
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload</title>
          <path d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
        
        callback: () => handleReloadData(),
        },
      ];
        useEffect(() => {
    dispatch(accountTypes.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/rms/account-types/list`,
      entity: 'accountTypes',
      jsonData: {}
    }))
  }, []);


	useEffect(() => {
        createColumnDefs()
        fetchOneuserList()
        let accountTypeItem = _.find(accountTypeListData.result.items, ['Name', 'ONEUser']);
    setSelectAccountTypeId(accountTypeItem?.Id)
	}, [pageData,pageSize,accountTypeListData])
  const handleDelete=(data: any)=>{
    dispatch(oneUsers.delete({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/one/one-users/delete`,
      entity: 'oneUser',
      jsonData: {
        Records: [
          {
         
                Id: data?.Id
            }
          
        ]
      }
  })).then(() => {
    dispatch(oneUsers.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/one/one-users/list`,entity:'oneUser',jsonData:{
  
    "PageNumber": pageData,
    "PageSize": pageSize,
    "SortField": "Id",
    "SortOrder": "desc",
    

    }}))
  });
  }


   const handleExportOneuserAccounts = async () => {
    dispatch(oneUsers.generateDataExport({
      url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/rms/accounts/export-accounts`,
      entity: 'ExportOneuserAccounts',
      jsonData: {
        Context: {},
        Records: [
          {
            TypeId: selectAccountTypeId
          }
        ]
      }
    })).then(() => {
      setExportsData(true)
    })
  };

    useEffect(() => {
    if (exportsData) {
      const blob1 = new Blob([exportOneuserAccountData?.result?.items], { type: 'multipart/form-data' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob1);
      const today = moment()
        .startOf('day' as moment.unitOfTime.StartOf)
        .format();
      const fileName = `${today}_OneuserAccounts.csv`;
      link.download = fileName;
      link.click();
      setExportsData(false)
    }
  }, [exportsData])

   const handleEmptyTemplate = async () => {
    const fileUrl = require('../../../../../assets/data/Upload ONEUser 1.csv');
    const link = document.createElement("a");
    link.href = fileUrl;
    link.setAttribute("download", "oneuser.csv"); 
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

   const handleUploadClickOneuserAccounts = () => {
    dispatch(settings.set({ getUploadModal: 'open' }))
  };

  
  const handleUploadClick = async (data: any) => {
    const frmData = new FormData();
    frmData.append(
      'formFile',    
      data
    );
    await dispatch(oneUsers.resetAction({ actionType: 'uploadCreate' }))
    await dispatch(oneUsers.uploadCreate({
      url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/rms/accounts/upload-accounts`,
      entity: 'uploadVendorAccounts',
      jsonData:
        frmData
    }));
    handleUploadClose();
  };

  
  const handleUploadClose = () => {
    dispatch(settings.set({ getUploadModal: 'close' }))
  }




  
  useEffect(() => {
    if (!uploadOneuserAccountData?.isSuccess && uploadOneuserAccountData?.result?.Error?.message) {
      toast.error(uploadOneuserAccountData?.result?.Error?.message)
    }
    if (uploadOneuserAccountData?.isSuccess) {
      toast.success("Oneuser Account uploaded successfully")
    }
    fetchOneuserList();
  }, [uploadOneuserAccountData]);

	return (
    <>
    {getUploadModal == 'open' && <UploadCommonModal title='Upload Oneuser Account' onSubmit={handleUploadClick} handleClose={handleUploadClose} handleEmptyTemplate={handleEmptyTemplate}/>}
      
    {OneUserItems?.isLoading ?  <PageLoader />: 
		<Table   
     checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'Id',
          }}
    enableFilter={true}
      IsPublishOneuserAccounts={true}
        handleExportOneuserAccounts={handleExportOneuserAccounts}
      
        handleUploadClickOneuserAccounts={handleUploadClickOneuserAccounts}
    filterTypeLists={filterTypes}
    onSearch={handleSearch} columnData={columnDefs} rowData={OneUserItems?.result?.items} setPageData={setPageData}
    setPageSize={setPageSize}paginationData={OneUserItems?.result?.pagination} onEdit={handleEdit} additionButtons={additionButtons} onDelete={handleDelete}headingName="One User"/>
     
  }
  </> 
	);
};

export default OneUsers;